import {Product} from "../types.ts";
import {PlatformLoader} from "@flexinet/ui-components";
import {
    PlatformServicePlan,
    PlatformServicePlanType
} from "@flexinet/pricing-components";
import {useProductLineItems} from "../../product-line-items";
import {useEffect} from "react";
import {ProductLineItem} from "../../product-line-items/types.ts";
import {usePrices} from "../../prices";
import {Price} from "../../prices/types";
import {stage} from "../../../config/stage.ts";


// product tile component
export const ProductComponent = (
    {
        product
    }: {
        product: Product
    }) => {

    const {
        items: lineItems,
        fetchRecords: fetchLineItems
    } = useProductLineItems(product.id)

    const {
        items: prices,
        fetchRecords: fetchPrices
    } = usePrices(product.id)

    useEffect(() => {
        fetchLineItems()
        fetchPrices()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product.id])

    if (typeof lineItems === 'undefined') {
        return <PlatformLoader message={'Loading product details...Please, wait!'}/>
    }

    const productLineItems = lineItems.map((lineItem: ProductLineItem) => {
        return {
            title: lineItem.productFeature?.name || lineItem.productFeatureId,
            supported: Boolean(lineItem.id)
        }
    })

    const normalizedPrices = prices.map((price: Price) => {
        return {
            ...price,
            amount: price.amount / 100,
        }
    })

    const plan = {
        ...product,
        description: product.shortDescription,
        prices: normalizedPrices,
        features: productLineItems
    } as PlatformServicePlanType

    return (
        <PlatformServicePlan key={product.id} plan={plan} stage={stage}/>
    );

}
